import React from 'react';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import { withStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import Card from '@material-ui/core/Card';
import CardActionArea from '@material-ui/core/CardActionArea';
import CardMedia from '@material-ui/core/CardMedia';
import { TableBody } from '@material-ui/core';
import usageTypes from '../../constants/UsageType';

const styles = {
  detailTable: {
    width: '100%'
  },
  tableCellItem: {
    borderBottom: '1px solid #DDDDDD',
    borderTop: '1px solid #DDDDDD',
    backgroundColor: '#F7F7F7',
    fontSize: 12,
    fontWeight: 'bold',
    padding: 10,
    // whiteSpace: 'nowrap',
    width: 100
  },
  tableCellData: {
    borderTop: '1px solid #DDDDDD',
    borderBottom: '1px solid #DDDDDD',
    padding: '12px 10px',
    fontSize: 12,
    whiteSpace: 'pre-line'
  },
  userImage: {
    width: '100px',
    height: '100px'
  },
  tag: {
    margin: '0px 10px 0px 0px',
    backgroundColor: '#fee'
  }
};

const enhance = compose(
  connect(state => ({
    taxTypes: state.gochiMenus.taxTypes
  }))
);

const ShopTable = enhance(
  ({
    classes,
    menuId,
    menuName,
    price,
    taxTypeStr,
    reducedTaxTypeStr,
    description,
    createdAt,
    updatedAt,
    tags,
    image,
    priceCombo,
    quantityRelease,
    quantityPromotion,
    promotionDescription,
    usageLimit,
    expiration,
    expirationEndDate,
    genreName,
    menuLimitTotal,
    usageType,
    shopName,
    taxType,
    taxTypes
  }) => {
    const USAGE_TYPE_MENU = usageTypes[0].id;
    const USAGE_TYPE_VOUCHER = usageTypes[1].id;
    const USAGE_TYPE_COMBO = usageTypes[2].id;

    return (
      <Table className={classes.detailTable}>
        <TableBody>
          <TableRow>
            <TableCell className={classes.tableCellItem}>メニューID</TableCell>
            <TableCell className={classes.tableCellData}>{menuId}</TableCell>
          </TableRow>
          <TableRow>
            <TableCell className={classes.tableCellItem}>用途</TableCell>
            <TableCell className={classes.tableCellData}>
              {(() => {
                if (usageType) {
                  const usageTypeName = usageTypes.find(
                    usage => usage.id.toString() === usageType.toString()
                  ).name;
                  return usageTypeName;
                }
                return '';
              })()}
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell className={classes.tableCellItem}>店舗名</TableCell>
            <TableCell className={classes.tableCellData}>{shopName}</TableCell>
          </TableRow>
          {usageType === USAGE_TYPE_MENU && (
            <>
              <TableRow>
                <TableCell className={classes.tableCellItem}>
                  メニュー名
                </TableCell>
                <TableCell className={classes.tableCellData}>
                  {menuName}
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell className={classes.tableCellItem}>
                  メニュー画像
                </TableCell>
                <TableCell className={classes.tableCellData}>
                  <Card className={classes.userImage}>
                    <CardActionArea>
                      <CardMedia component="img" image={image} />
                    </CardActionArea>
                  </Card>
                </TableCell>
              </TableRow>
            </>
          )}
          {usageType !== USAGE_TYPE_COMBO ? (
            <TableRow>
              <TableCell className={classes.tableCellItem}>価格</TableCell>
              <TableCell className={classes.tableCellData}>
                {parseInt(price, 10).toLocaleString()}
                {`円`}
              </TableCell>
            </TableRow>
          ) : (
            <TableRow>
              <TableCell className={classes.tableCellItem}>
                単価×発行枚数
              </TableCell>
              <TableCell className={classes.tableCellData}>
                {`${parseInt(
                  priceCombo,
                  10
                ).toLocaleString()}円ｘ${quantityRelease}枚`}
              </TableCell>
            </TableRow>
          )}
          <TableRow>
            <TableCell className={classes.tableCellItem}>税区分</TableCell>
            <TableCell className={classes.tableCellData}>
              {taxType === 'DONATION'
                ? taxTypes.map(item => {
                    if (item.id.toString() === 'INTERNAL') {
                      return item.name;
                    }
                    return '';
                  })
                : taxTypeStr}
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell className={classes.tableCellItem}>
              軽減税率対象
            </TableCell>
            <TableCell className={classes.tableCellData}>
              {reducedTaxTypeStr}
            </TableCell>
          </TableRow>
          {usageType === USAGE_TYPE_COMBO && (
            <>
              <TableRow>
                <TableCell className={classes.tableCellItem}>
                  付与無料枚数
                </TableCell>
                <TableCell className={classes.tableCellData}>
                  {quantityPromotion ? `${quantityPromotion}枚` : ''}
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell className={classes.tableCellItem}>おまけ</TableCell>
                <TableCell className={classes.tableCellData}>
                  {promotionDescription}
                </TableCell>
              </TableRow>
            </>
          )}
          <TableRow>
            <TableCell className={classes.tableCellItem}>ジャンル</TableCell>
            <TableCell className={classes.tableCellData}>{genreName}</TableCell>
          </TableRow>
          {usageType === USAGE_TYPE_MENU && (
            <TableRow>
              <TableCell className={classes.tableCellItem}>説明</TableCell>
              <TableCell className={classes.tableCellData}>
                {description}
              </TableCell>
            </TableRow>
          )}
          <TableRow>
            <TableCell className={classes.tableCellItem}>タグ</TableCell>
            <TableCell className={classes.tableCellData}>
              <div>
                {tags.map(tag => {
                  return <span className={classes.tag}>{tag.tagName}</span>;
                })}
              </div>
            </TableCell>
          </TableRow>
          {usageType !== USAGE_TYPE_MENU && (
            <>
              <TableRow>
                <TableCell className={classes.tableCellItem}>
                  メニュー名
                </TableCell>
                <TableCell className={classes.tableCellData}>
                  {menuName}
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell className={classes.tableCellItem}>
                  メニュー画像
                </TableCell>
                <TableCell className={classes.tableCellData}>
                  <Card className={classes.userImage}>
                    <CardActionArea>
                      <CardMedia component="img" image={image} />
                    </CardActionArea>
                  </Card>
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell className={classes.tableCellItem}>説明</TableCell>
                <TableCell className={classes.tableCellData}>
                  {description}
                </TableCell>
              </TableRow>
            </>
          )}
          {usageType === USAGE_TYPE_COMBO && (
            <TableRow>
              <TableCell className={classes.tableCellItem}>利用制限</TableCell>
              <TableCell className={classes.tableCellData}>
                {usageLimit === 1 ? '1日1枚' : 'なし'}
              </TableCell>
            </TableRow>
          )}
          <TableRow>
            <TableCell className={classes.tableCellItem}>利用期間</TableCell>
            <TableCell className={classes.tableCellData}>
              {expiration ? `${expiration}日間` : expirationEndDate}
            </TableCell>
          </TableRow>
          {usageType === USAGE_TYPE_VOUCHER && (
            <TableRow>
              <TableCell className={classes.tableCellItem}>利用方法</TableCell>
              <TableCell className={classes.tableCellData}>
                {menuLimitTotal === 1 ? '一円単位利用' : '一枚単位利用'}
              </TableCell>
            </TableRow>
          )}
          {usageType !== USAGE_TYPE_COMBO && (
            <TableRow>
              <TableCell className={classes.tableCellItem}>寄付設定</TableCell>
              <TableCell className={classes.tableCellData}>
                {taxType === 'DONATION' ? '対象内' : '対象外'}
              </TableCell>
            </TableRow>
          )}
          <TableRow>
            <TableCell className={classes.tableCellItem}>登録日時</TableCell>
            <TableCell className={classes.tableCellData}>{createdAt}</TableCell>
          </TableRow>
          <TableRow>
            <TableCell className={classes.tableCellItem}>更新日時</TableCell>
            <TableCell className={classes.tableCellData}>{updatedAt}</TableCell>
          </TableRow>
        </TableBody>
      </Table>
    );
  }
);

export default withStyles(styles)(ShopTable);
